module.exports = __webpack_public_path__ + "static/assets/24a18c39cf49ac3797806a525e07cd7b.jpg";